import { CalendarRange } from 'lucide-react';
import { useState } from 'react';
import { RANGE_PRESETS, type PresetId, type RangeSelection } from '../../lib/time';
import { DateRangeForm, SegmentedControl, type SegmentOption } from '../molecules';

type RangeOption = PresetId | 'custom';

const RANGE_OPTIONS: SegmentOption<RangeOption>[] = [
  ...RANGE_PRESETS.map((p) => ({ value: p.id, label: p.label })),
  { value: 'custom', label: 'Custom', icon: <CalendarRange size={14} aria-hidden /> },
];

interface RangePickerProps {
  range: RangeSelection;
  onChange: (range: RangeSelection) => void;
}

/** Time range for everything on the page, on the band: presets first, custom dates last. */
export function RangePicker({ range, onChange }: RangePickerProps) {
  const [customOpen, setCustomOpen] = useState(range.kind === 'custom');
  const selected: RangeOption = range.kind === 'custom' ? 'custom' : range.preset;

  function select(option: RangeOption) {
    if (option === 'custom') return setCustomOpen(!customOpen);
    setCustomOpen(false);
    onChange({ kind: 'preset', preset: option });
  }

  return (
    <div className="flex flex-col items-start gap-2 sm:items-end">
      <SegmentedControl options={RANGE_OPTIONS} value={selected} onChange={select} ariaLabel="Time range" appearance="band" />
      {customOpen && (
        <div className="rounded-xl bg-surface p-2 text-fg shadow-popover">
          <DateRangeForm initial={range.kind === 'custom' ? range : undefined} onApply={(custom) => onChange({ kind: 'custom', ...custom })} />
        </div>
      )}
    </div>
  );
}
